import React, { Component } from 'react';
import './styles.css';
import BusinessPlanSectionMenuLayout from '../BusinessPlanSectionMenuLayout';
import { formatRoute } from 'react-router-named-routes';
import { Route } from 'react-router-dom';
import {
	SALES,
	PRODUCTION,
	PROCUREMENT,
	SALESTEST,
	SALESPROGRAM,
	PRODUCTIONPROGRAM,
	PRODUCTIONINTERNALLY,
	PRODUCTIONEXTERNALLY,
	PRODUCTIONQUALITYCHECK,
	PRODUCTIONFIXEDCOSTS,
	PROCUREMENTOVERVIEW,
	PROCUREMENTSUPPLIER,
	PROCUREMENTINVENTORY,
	PROCUREMENTCOST
} from '../../routes';
class BusinessPlanSectionMenu extends Component {
	render() {
		const { game, match } = this.props;
		const route = path =>
			formatRoute(path, {
				gameID: game.id,
				businessPlanID: match.params.businessPlanID
			});
		const data = [
			{
				section: SALES,
				items: [
					{ to: route(SALESTEST), label: 'test' },
					{ to: route(SALESPROGRAM), label: 'sales program' }
				]
			},
			{
				section: PRODUCTION,
				items: [
					{ to: route(PRODUCTIONPROGRAM), label: 'production program' },
					{ to: route(PRODUCTIONINTERNALLY), label: 'internally' },
					{ to: route(PRODUCTIONEXTERNALLY), label: 'externally' },
					{ to: route(PRODUCTIONQUALITYCHECK), label: 'quality check' },
					{ to: route(PRODUCTIONFIXEDCOSTS), label: 'fixed costs' }
				]
			},
			{
				section: PROCUREMENT,
				items: [
					{ to: route(PROCUREMENTOVERVIEW), label: 'overview' },
					{ to: route(PROCUREMENTSUPPLIER), label: 'supplier' },
					{
						to: route(PROCUREMENTINVENTORY),
						label: 'direct materials purchases/inventory'
					},
					{ to: route(PROCUREMENTCOST), label: 'costs' }
				]
			}
		];
		return (
			<div className="business-plan-section-menu">
				{data.map(row => (
					<Route
						key={row.section}
						path={row.section}
						render={props => (
							<BusinessPlanSectionMenuLayout items={row.items} {...props} />
						)}
					/>
				))}
			</div>
		);
	}
}

export default BusinessPlanSectionMenu;
